import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

type StyledTypes = {
  background?: string;
  color?: string;
  isLiftStationMobile?: boolean;
};

const StyledLabelTagBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isLiftStationMobile',
})(({ background, color, isLiftStationMobile }: StyledTypes) => ({
  justifyContent: 'center',
  alignItems: 'center',
  display: 'flex',
  overflow: 'hidden',

  flexShrink: 1,
  flexGrow: 0,
  width: 'auto',
  minWidth: isLiftStationMobile ? '55px' : '60px',
  maxWidth: '100%',

  minHeight: isLiftStationMobile ? '20px' : '22px',
  background: background,
  border: `1.5px solid ${color}`,
  borderRadius: '6px',
  padding: '0 2px',

  WebkitBoxOrient: 'vertical',
  textOverflow: 'ellipsis',
  wordBreak: 'break-word',
}));

const StyledLabelTagValue = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'isLiftStationMobile',
})(({ isLiftStationMobile }: StyledTypes) => ({
  fontSize: isLiftStationMobile ? '10px' : '11px',
  color: '#3B3B3B',
  fontWeight: '700',

  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 2,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  wordBreak: 'break-word',
  whiteSpace: 'normal',
  textAlign: 'center',
  lineHeight: 1.25,
}));

export { StyledLabelTagBox, StyledLabelTagValue };
